import ProfileAvatar from "../avatar/ProfileAvatar";
import {
	CATALOG_DOCTOR_EMPTY_LABEL,
	instructorPersonLabel,
} from "./catalogInstructorDisplay";

/** @param {{ instructors_detail?: array } | null | undefined} item */
export function listCatalogInstructors(item) {
	const raw = item?.instructors_detail ?? [];
	return raw
		.map((person) => ({
			key: person?.doctor_id ?? person?.phone_number ?? instructorPersonLabel(person),
			name: instructorPersonLabel(person),
			avatarUrl: person?.avatar_url,
		}))
		.filter((person) => person.name);
}

function buildInstructorRows(people, fallbackSubtitle, subtitleMuted) {
	if (people.length === 0) {
		if (subtitleMuted || !fallbackSubtitle) {
			return { rows: [{ name: CATALOG_DOCTOR_EMPTY_LABEL, avatarUrl: undefined }], isEmpty: true };
		}
		return { rows: [{ name: fallbackSubtitle, avatarUrl: undefined }], isEmpty: false };
	}
	if (people.length === 1) {
		return { rows: [people[0]], isEmpty: false };
	}
	if (people.length === 2) {
		return { rows: [people[0], people[1]], isEmpty: false };
	}
	const rest = people.length - 2;
	return {
		rows: [
			people[0],
			{
				key: "more",
				name: `${people[1].name} و ${rest} استاد دیگر`,
				avatarUrl: people[1].avatarUrl,
			},
		],
		isEmpty: false,
	};
}

function InstructorLine({ person, onDark, isEmpty, subtitleMuted }) {
	return (
		<div className="flex min-w-0 flex-1 items-center justify-start gap-1.5">
			<ProfileAvatar
				imageUrl={person.avatarUrl}
				name={person.name}
				size="sm"
				variant={onDark ? "onDark" : "light"}
				className="shrink-0 !h-[22px] !w-[22px] [&_span]:!text-[9px]"
			/>
			<span
				className={[
					"min-w-0 flex-1 truncate text-[12px] leading-tight",
					isEmpty || subtitleMuted
						? "font-Vazir-400 text-darkBlue/45"
						: "font-Vazir-500 text-darkBlue",
					onDark && !isEmpty && !subtitleMuted ? "!text-white/92" : "",
					onDark && (isEmpty || subtitleMuted) ? "!text-white/55" : "",
				].join(" ")}
			>
				{person.name}
			</span>
		</div>
	);
}

export default function CatalogInstructorRow({
	item,
	subtitle,
	instructorAvatarUrl,
	subtitleMuted = false,
	variant = "light",
	className = "",
}) {
	const people = item ? listCatalogInstructors(item) : [];
	const onDark = variant === "onDark";

	const fallbackPerson =
		subtitle && !subtitleMuted
			? { key: "solo", name: subtitle, avatarUrl: instructorAvatarUrl }
			: null;

	const { rows, isEmpty } =
		people.length > 0
			? buildInstructorRows(people, subtitle, subtitleMuted)
			: buildInstructorRows(
					fallbackPerson ? [fallbackPerson] : [],
					subtitle,
					subtitleMuted,
				);

	const fullTitle = people.length > 0 ? people.map((p) => p.name).join("، ") : rows[0]?.name;

	return (
		<div
			dir="rtl"
			className={[
				"flex h-[52px] min-h-[52px] max-h-[52px] w-full flex-col justify-center gap-0.5 overflow-hidden text-right",
				className,
			].join(" ")}
			title={fullTitle}
		>
			{rows.map((person, index) => (
				<InstructorLine
					key={person.key ?? `${person.name}-${index}`}
					person={person}
					onDark={onDark}
					isEmpty={isEmpty}
					subtitleMuted={subtitleMuted}
				/>
			))}
		</div>
	);
}
